// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes szh-menu-show-slide-left {
  from {
    opacity: 0;
    transform: translateX(0.75rem);
  }
}
@keyframes szh-menu-hide-slide-left {
  to {
    opacity: 0;
    transform: translateX(0.75rem);
  }
}
@keyframes szh-menu-show-slide-right {
  from {
    opacity: 0;
    transform: translateX(-0.75rem);
  }
}
@keyframes szh-menu-hide-slide-right {
  to {
    opacity: 0;
    transform: translateX(-0.75rem);
  }
}
@keyframes szh-menu-show-slide-top {
  from {
    opacity: 0;
    transform: translateY(0.75rem);
  }
}
@keyframes szh-menu-hide-slide-top {
  to {
    opacity: 0;
    transform: translateY(0.75rem);
  }
}
@keyframes szh-menu-show-slide-bottom {
  from {
    opacity: 0;
    transform: translateY(-0.75rem);
  }
}
@keyframes szh-menu-hide-slide-bottom {
  to {
    opacity: 0;
    transform: translateY(-0.75rem);
  }
}
.szh-menu--state-opening.szh-menu--dir-left {
  animation: szh-menu-show-slide-left 0.15s ease-out;
}

.szh-menu--state-closing.szh-menu--dir-left {
  animation: szh-menu-hide-slide-left 0.15s ease-in forwards;
}

.szh-menu--state-opening.szh-menu--dir-right {
  animation: szh-menu-show-slide-right 0.15s ease-out;
}

.szh-menu--state-closing.szh-menu--dir-right {
  animation: szh-menu-hide-slide-right 0.15s ease-in forwards;
}

.szh-menu--state-opening.szh-menu--dir-top {
  animation: szh-menu-show-slide-top 0.15s ease-out;
}

.szh-menu--state-closing.szh-menu--dir-top {
  animation: szh-menu-hide-slide-top 0.15s ease-in forwards;
}

.szh-menu--state-opening.szh-menu--dir-bottom {
  animation: szh-menu-show-slide-bottom 0.15s ease-out;
}

.szh-menu--state-closing.szh-menu--dir-bottom {
  animation: szh-menu-hide-slide-bottom 0.15s ease-in forwards;
}
`, "",{"version":3,"sources":["webpack://./../../../node_modules/@szhsin/react-menu/dist/transitions/slide.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;AACA;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;AACA;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;AACA;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;AACA;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;AACA;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;AACA;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;AACA;EACE;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,4DAA4D;AAC9D","sourcesContent":["@keyframes szh-menu-show-slide-left {\n  from {\n    opacity: 0;\n    transform: translateX(0.75rem);\n  }\n}\n@keyframes szh-menu-hide-slide-left {\n  to {\n    opacity: 0;\n    transform: translateX(0.75rem);\n  }\n}\n@keyframes szh-menu-show-slide-right {\n  from {\n    opacity: 0;\n    transform: translateX(-0.75rem);\n  }\n}\n@keyframes szh-menu-hide-slide-right {\n  to {\n    opacity: 0;\n    transform: translateX(-0.75rem);\n  }\n}\n@keyframes szh-menu-show-slide-top {\n  from {\n    opacity: 0;\n    transform: translateY(0.75rem);\n  }\n}\n@keyframes szh-menu-hide-slide-top {\n  to {\n    opacity: 0;\n    transform: translateY(0.75rem);\n  }\n}\n@keyframes szh-menu-show-slide-bottom {\n  from {\n    opacity: 0;\n    transform: translateY(-0.75rem);\n  }\n}\n@keyframes szh-menu-hide-slide-bottom {\n  to {\n    opacity: 0;\n    transform: translateY(-0.75rem);\n  }\n}\n.szh-menu--state-opening.szh-menu--dir-left {\n  animation: szh-menu-show-slide-left 0.15s ease-out;\n}\n\n.szh-menu--state-closing.szh-menu--dir-left {\n  animation: szh-menu-hide-slide-left 0.15s ease-in forwards;\n}\n\n.szh-menu--state-opening.szh-menu--dir-right {\n  animation: szh-menu-show-slide-right 0.15s ease-out;\n}\n\n.szh-menu--state-closing.szh-menu--dir-right {\n  animation: szh-menu-hide-slide-right 0.15s ease-in forwards;\n}\n\n.szh-menu--state-opening.szh-menu--dir-top {\n  animation: szh-menu-show-slide-top 0.15s ease-out;\n}\n\n.szh-menu--state-closing.szh-menu--dir-top {\n  animation: szh-menu-hide-slide-top 0.15s ease-in forwards;\n}\n\n.szh-menu--state-opening.szh-menu--dir-bottom {\n  animation: szh-menu-show-slide-bottom 0.15s ease-out;\n}\n\n.szh-menu--state-closing.szh-menu--dir-bottom {\n  animation: szh-menu-hide-slide-bottom 0.15s ease-in forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
